import React from 'react';
import {
  FaAddressBook,
  FaArchive,
  FaAward,
  FaBolt,
  FaBook,
  FaBookmark,
  FaBookOpen,
  FaBrain,
  FaBuilding,
  FaCalendarCheck,
  FaChalkboardTeacher,
  FaChartBar,
  FaChartLine,
  FaCheck,
  FaClone,
  FaCog,
  FaColumns,
  FaCommentDots,
  FaExternalLinkAlt,
  FaFile,
  FaFileExport,
  FaFileSignature,
  FaFistRaised,
  FaFolder,
  FaGraduationCap,
  FaHandPointer,
  FaHandsHelping,
  FaHome,
  FaImage,
  FaLaptop,
  FaLightbulb,
  FaList,
  FaLock,
  FaMicrosoft,
  FaMousePointer,
  FaPenAlt,
  FaPlug,
  FaPodcast,
  FaPoll,
  FaQuestion,
  FaSchool,
  FaSearch,
  FaServer,
  FaShareAlt,
  FaShareSquare,
  FaSignInAlt,
  FaSortAmountDown,
  FaSortAmountUpAlt,
  FaSuitcase,
  FaTabletAlt,
  FaThumbsUp,
  FaTv,
  FaUniversalAccess,
  FaUser,
  FaUserSecret,
  FaUserTie,
  FaVideo,
  FaYoutube,
} from 'react-icons/fa';
import { HiPresentationChartLine } from 'react-icons/hi';
import {
  IoIosFilm,
  IoIosPeople,
  IoIosPhonePortrait,
  IoIosPricetags,
} from 'react-icons/io';

const Icons = {
  Accessibility: <FaUniversalAccess />,
  Address: <FaAddressBook />,
  Anonymous: <FaUserSecret />,
  Archive: <FaArchive />,
  Award: <FaAward />,
  Bolt: <FaBolt />,
  Book: <FaBook />,
  Bookmark: <FaBookmark />,
  Brain: <FaBrain />,
  Building: <FaBuilding />,
  Calendar: <FaCalendarCheck />,
  ChartBar: <FaChartBar />,
  ChartLine: <FaChartLine />,
  Check: <FaCheck />,
  Clone: <FaClone />,
  Cog: <FaCog />,
  Column: <FaColumns />,
  Comment: <FaCommentDots />,
  Export: <FaFileExport />,
  ExternalLink: <FaExternalLinkAlt />,
  File: <FaFile />,
  FileSignature: <FaFileSignature />,
  Film: <IoIosFilm />,
  Fist: <FaFistRaised />,
  Folder: <FaFolder />,
  Graduate: <FaGraduationCap />,
  HandPointer: <FaHandPointer />,
  HandsHelping: <FaHandsHelping />,
  Home: <FaHome />,
  Image: <FaImage />,
  Laptop: <FaLaptop />,
  LightbulbOn: <FaLightbulb />,
  List: <FaList />,
  Locker: <FaLock />,
  MousePointer: <FaMousePointer />,
  Node: <FaShareAlt />,
  OpenBook: <FaBookOpen />,
  Pen: <FaPenAlt />,
  People: <IoIosPeople />,
  Phone: <IoIosPhonePortrait />,
  Plug: <FaPlug />,
  Podcast: <FaPodcast />,
  Poll: <FaPoll />,
  Presentation: <HiPresentationChartLine />,
  Price: <IoIosPricetags />,
  Question: <FaQuestion />,
  School: <FaSchool />,
  Search: <FaSearch />,
  Servers: <FaServer />,
  Share: <FaShareSquare />,
  SortUp: <FaSortAmountUpAlt />,
  SortBottom: <FaSortAmountDown />,
  Suitcase: <FaSuitcase />,
  Teacher: <FaChalkboardTeacher />,
  Signin: <FaSignInAlt />,
  ThumbsUp: <FaThumbsUp />,
  Tablet: <FaTabletAlt />,
  Tie: <FaUserTie />,
  Tv: <FaTv />,
  User: <FaUser />,
  Video: <FaVideo />,
  Youtube: <FaYoutube />,
  Window: <FaMicrosoft />,
};

export const getIcon = iconName => Icons[iconName] || Icons.Check;
